module.exports = __webpack_public_path__ + "static/media/spinner-third.e9186e04.svg";